// Integrations that answer the standard quote calls and share the quote-style policy inputs
// (indexation, interest rates, premium type). UnderWriteMe drives its own journey and inputs.
// Mirrors PricingIntegrations.QuoteIntegrationsByPreference on the server.
export const QUOTE_INTEGRATIONS = ['IPIPELINE', 'IRESS'];

export function isQuoteIntegration(integration) {
    return QUOTE_INTEGRATIONS.includes(integration);
}

// Apply hands the adviser over to the quote service's new-business journey: iPipeline and UnderwriteMe by
// quote id, The Exchange through its Launch Application service (the only route the Service Order allows for
// an Exchange quote). Analyses saved before integrations were recorded (null) are iPipeline ones.
export function supportsApply(integration) {
    return integration === null || integration === undefined || ['IPIPELINE', 'UNDERWRITEME', 'IRESS'].includes(integration);
}

// Indexation choices for term-style tools. The Exchange only distinguishes level from increasing cover and each
// provider applies its own escalation basis, so Iress users choose between the two; iPipeline takes the basis itself.
const FULL_TERM_INDEXATION = [
    { label: 'AWEI', value: 'AWEI' },
    { label: 'RPI', value: 'RPI' },
    { label: 'Level', value: 'Level' },
    { label: '1%', value: 'One' },
    { label: '2%', value: 'Two' },
    { label: '3%', value: 'Three' },
    { label: '4%', value: 'Four' },
    { label: '5%', value: 'Five' },
    { label: '6%', value: 'Six' },
    { label: '7%', value: 'Seven' },
    { label: '8%', value: 'Eight' },
    { label: '9%', value: 'Nine' },
    { label: '10%', value: 'Ten' },
];

const IRESS_TERM_INDEXATION = [
    { label: 'Level', value: 'Level' },
    { label: 'Increasing', value: 'RPI' },
];

export function termIndexationOptions(integration) {
    return integration === 'IRESS' ? IRESS_TERM_INDEXATION : FULL_TERM_INDEXATION;
}

export function familyIncomeIndexationOptions(integration) {
    return integration === 'IRESS' ? IRESS_TERM_INDEXATION : [{ label: 'RPI', value: 'RPI' }, { label: 'Level', value: 'Level' }];
}
